import { render, staticRenderFns } from "./TemplateWhatsappAdd.vue?vue&type=template&id=ef849a0c&"
import script from "./TemplateWhatsappAdd.vue?vue&type=script&lang=js&"
export * from "./TemplateWhatsappAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports